import { EmojiDrawer, validTypes } from "./EmojiDrawer.js";
export async function loadEmojiShape(engine, refresh = true) {
    await engine.addShape(validTypes, new EmojiDrawer(), refresh);
}
